import React from "react";

import Collection from "./collection";

const CollectionList = ({ collections }) => (
    <ol>
        {collections &&
            collections.map(collection => (
                <li
                    id={`collection-${collection.id}`}
                    className="collection clearfix"
                    key={collection.id}
                >
                    <Collection collection={collection} />
                </li>
            ))}
    </ol>
);

export default CollectionList;
